Number.prototype.clamp = function (min, max) {
    return Math.min(Math.max(this, min), max);
};

function PagingTemplate(totalPage, currentPage, type, path, topN, investUrl) {

    var template = "";
    var TotalPages = totalPage;
    var CurrentPage = currentPage;
    var PageNumberArray = [];

    var countIncr = 1;
    var startPage;
    if (currentPage == 1) startPage = 1;
    else startPage = currentPage - 1;

    for (var i = startPage; i <= totalPage; i++) {
        PageNumberArray[0] = startPage;
        if (totalPage != currentPage - 1 && PageNumberArray[countIncr - 1] != totalPage) {
            PageNumberArray[countIncr] = i + 1;
        }
        countIncr++;
    };

    PageNumberArray = PageNumberArray.slice(0, 5);
    var FirstPage = 1;
    var LastPage = totalPage;
    var prev = (currentPage - 1).clamp(FirstPage, LastPage);
    var next = (currentPage + 1).clamp(FirstPage, LastPage);

    template += `<input type='hidden' id='prevPage' value='${prev}' />`;
    template += `<input type='hidden' id='nextPage' value='${next}' />`;

    template += `<nav aria-label="Pager navigation">`;
    template += `<ul class='pagination justify-content-center'>`;
    template += `<li class='page-item'><a class='page-link' href="#" data-pager-page="${FirstPage}" data-pager-type="${type}" data-pager-path="${path}" data-pager-topn="${topN}" data-pager-investurl="${investUrl}" aria-label='First'><i class='fa fa-angle-double-left' aria-hidden='true'></i><span class='sr-only'>First</span></a></li>`;
    template += `<li class='page-item'><a class='page-link prev-page' href="#" data-pager-page="${prev}" data-pager-type="${type}" data-pager-path="${path}" data-pager-topn="${topN}" data-pager-investurl="${investUrl}" aria-label='Previous'><i class='fa fa-angle-left' aria-hidden='true'></i><span class='sr-only'>Previous</span></a></li>`;

    for (var i = 0; i < PageNumberArray.length; i++) {
        if (PageNumberArray[i] == currentPage) {
            template += `<li class='page-item ml-1 active'><a class='page-link' href="#" data-pager-page="${PageNumberArray[i]}" data-pager-type="${type}" data-pager-path="${path}" data-pager-topn="${topN}" data-pager-investurl="${investUrl}">${PageNumberArray[i]}</a></li>`;
        } else {
            template += `<li class='page-item ml-1'><a class='page-link' href="#" data-pager-page="${PageNumberArray[i]}" data-pager-type="${type}" data-pager-path="${path}" data-pager-topn="${topN}" data-pager-investurl="${investUrl}">${PageNumberArray[i]}</a></li>`;
        }
    }

    template += `<li class='page-item ml-1'><a class='page-link next-page' href="#" data-pager-page="${next}" data-pager-type="${type}" data-pager-path="${path}" data-pager-topn="${topN}" data-pager-investurl="${investUrl}" aria-label='Next'><i class='fa fa-angle-right' aria-hidden='true'></i><span class='sr-only'>Next</span></a></li>`;
    template += `<li class='page-item'><a class='page-link' href="#" data-pager-page="${LastPage}" data-pager-type="${type}" data-pager-path="${path}" data-pager-topn="${topN}" data-pager-investurl="${investUrl}" aria-label='Last'><i class='fa fa-angle-double-right' aria-hidden='true'></i><span class='sr-only'>Last</span></a></li>`;
    template += `</ul></nav>`;

    return template;
}